import {Controller} from "@hotwired/stimulus";

// Connects to data-controller="zoom"
export default class extends Controller {
  static targets = ["image"];

  connect() {
    this.isZoomed = false;
    this.zoomLayer = null;
  }

  toggle(event) {
    this.isZoomed ? this.disableZoom() : this.enableZoom(event);
  }

  pan(event) {
    if (!this.isZoomed || event.type !== "mousemove") return;
    this.updateBackgroundPosition(event.clientX, event.clientY);
  }

  enableZoom(event) {
    this.isZoomed = true;
    this.element.classList.add("zoomed");

    this.zoomLayer = document.createElement("div");
    this.zoomLayer.classList.add("zoom-layer");

    const highRes = this.element.dataset.zoomHighResUrl;
    this.zoomLayer.style.backgroundImage = `url(${highRes})`;

    if (this.hasImageTarget) {
      this.imageTarget.parentNode.insertBefore(this.zoomLayer, this.imageTarget);
    } else {
      console.error("Stimulus target 'image' not found for zoom.");
      this.disableZoom();
      return;
    }

    this.updateBackgroundPosition(event.clientX, event.clientY);
  }

  disableZoom() {
    this.isZoomed = false;
    this.element.classList.remove("zoomed");

    if (this.zoomLayer) {
      this.zoomLayer.remove();
      this.zoomLayer = null;
    }
  }

  updateBackgroundPosition(clientX, clientY) {
    if (!this.zoomLayer) return;

    const rect = this.element.getBoundingClientRect();
    const xPercent = ((clientX - rect.left) / rect.width) * 100;
    const yPercent = ((clientY - rect.top) / rect.height) * 100;

    this.zoomLayer.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  }

  openImage(event) {
    const highRes = event.currentTarget.dataset.highRes;
    const alt = event.currentTarget.dataset.alt;

    const modalImage = document.getElementById("zoom-modal-image");
    if (modalImage) {
      modalImage.src = highRes;
      modalImage.alt = alt;

      modalImage.scrollIntoView({
        block: "center",
        inline: "center",
      });
    }
  }

  closeImage() {
    const modalImage = document.getElementById("zoom-modal-image");
    if (modalImage) {
      modalImage.src = "";
      modalImage.alt = "";
    }
  }
}
